import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../../user/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'

import { IStateAndCountiesOptionsResponse } from '../../../../common/common.types'
import { OptionsService } from '../../../options/services/options.service'
import { EmployerConstants } from '../store/employer.constants'
import { IEmployerState } from '../store/employer.types'
import { getEmployerSelector } from '../selectors'
import { setEmployerCountyOptions } from '../../../options/store/options.actions'

export function* getEmployerCountyOptions() {
  try {
    const serviceId: string = yield select(getServiceIdSelector)
    const optionsService = new OptionsService(serviceId)

    const employer: IEmployerState = yield select(getEmployerSelector)
    const { state } = employer

    const response: IStateAndCountiesOptionsResponse = yield call([optionsService, optionsService.getCountyOptions])
    const { entity } = response

    const foundCountyObject = entity.find((obj) => obj.state === String(state?.id))
    const countiesToSet = foundCountyObject ? foundCountyObject.counties : []

    yield put(setEmployerCountyOptions(countiesToSet))
  } catch (e) {
    yield put(throwPcrException(`getEmployerCountyOptions() error: ${e}`))
  }
}

export function* getEmployerCountyOptionsSaga() {
  yield takeLatest([EmployerConstants.GET_EMPLOYER_COUNTY_OPTIONS], getEmployerCountyOptions)
}
